import React from 'react';
import './Footer.css';
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaEnvelope,
} from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">

      <div className="footer-content">

        {/* Section 1: Brand */}
        <div className="footer-section">
          <h3>Digital Agency</h3>
          <p>
            Transforming ideas into digital reality.
            We specialize in SEO, Branding, and Web Design.
          </p>
          <div className="social-icons">
            <a href="https://www.facebook.com/profile.php?id=61577990661651" className="social-icon"><FaFacebookF /></a>

            <a href="https://www.instagram.com/shak7.info?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D" className="social-icon"><FaInstagram /></a>
            <a href="#" className="social-icon"><FaLinkedinIn /></a>
          </div>
        </div>

        {/* Section 2: Contact */}
        <div className="footer-section">
          <h3>Contact Us</h3>
          <a href="tel:+8128188371" className="contact-link">
            <FaPhoneAlt size={16} /> +91 81281 88371
          </a>
          <a href="mailto:shak7.info@gmail.com" className="contact-link">
            <FaEnvelope size={16} /> shak7.info@gmail.com
          </a>
        </div>

        {/* Section 3: Location */}
        <div className="footer-section">
          <h3>Visit Us</h3>
          <div className="contact-link" style={{ alignItems: 'flex-start' , textAlign:'start' }}>
            <FaMapMarkerAlt size={18} style={{ marginTop: '4px' }} />
            <span>
              Jay Babari Complex,<br></br> Near HDFC Bank, Malhar Chowk,<br></br> Surendranagr
            </span>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} Shak7. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;